<script lang="ts">
    import {StatisticSentiment} from "../../types/statistics/statistic-sentiment.type";
    import type {Statistic} from "../../types/statistics/statistic.type";
    
    export let statistic: Statistic;
</script>

<div class="statistic">
    <span class="statistic-title">
        {statistic.label}
    </span>
    <div 
        class="statistic-value" 
        class:statistic-value--negative={statistic.sentiment === StatisticSentiment.Negative} 
        class:statistic-value--positive={statistic.sentiment === StatisticSentiment.Positive}
    >
        {statistic.value}
    </div>
</div>

<style lang="scss">
    @import '../../assets/scss/colors';

    .statistic {
        display: flex;
        flex-direction: column;
        min-width: 160px !important;

        &-title {
            font-size: 16px;
            color: var(--f7-text-color, #000);
            font-weight: bold;
        }

        &-subtitle {
            font-size: 12px;
            color: var(--f7-text-color, #666);
        }

        &-value {
            font-size: 24px;
            font-weight: bold;

            &--negative {
                color: $secondary;
            }

            &--positive {
                color: $primary;
            }
        }
    }
</style>
